/**
 * vizClient.js
 *
 * Cliente para comunicarse con el backend de IQVIA Agent
 * para generar SQL de visualización
 */

const BACKEND_URL = process.env.REACT_APP_IQVIA_BACKEND_URL || 'http://localhost:5000';

/**
 * Genera SQL optimizado para visualización usando Claude
 *
 * @param {string} userQuestion - Pregunta original del usuario
 * @param {string} botResponse - Respuesta textual del bot
 * @param {string} agentType - Tipo de agente ('subnacional' o 'nacional')
 * @returns {Promise<Object>} Resultado con SQL, data, columns, column_types
 */
export const generateVisualizationSQL = async (userQuestion, botResponse, agentType = 'subnacional') => {
    try {
        console.log('[VIZ-CLIENT] 📊 Generando SQL para visualización:', {
            agentType,
            question: userQuestion.substring(0, 100)
        });

        const response = await fetch(`${BACKEND_URL}/generate-viz-sql`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user_question: userQuestion,
                bot_response: botResponse,
                agent_type: agentType
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (!data.success) {
            throw new Error(data.error || 'Error desconocido generando SQL');
        }

        console.log('[VIZ-CLIENT] ✅ SQL generado exitosamente:', {
            sql: data.sql?.substring(0, 100),
            rows: data.rows_returned,
            columns: data.columns
        });

        return {
            success: true,
            sql: data.sql,
            data: data.data || [],
            columns: data.columns || [],
            column_types: data.column_types || {},
            rows_returned: data.rows_returned || 0
        };

    } catch (error) {
        console.error('[VIZ-CLIENT] ❌ Error:', error);

        return {
            success: false,
            error: error.message || 'Error al generar SQL de visualización',
            data: [],
            columns: [],
            column_types: {}
        };
    }
};

/**
 * Verifica la salud del backend
 *
 * @returns {Promise<boolean>} true si el backend está disponible
 */
export const checkBackendHealth = async () => {
    try {
        const response = await fetch(`${BACKEND_URL}/health`, {
            method: 'GET'
        });

        return response.ok;
    } catch (error) {
        console.error('[VIZ-CLIENT] ❌ Backend no disponible:', error);
        return false;
    }
};
